import React from "react";
import axios from "services/axios";
import Axios from "axios";
import { Button, Card, message, Spin, Tooltip } from "antd";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import momentTZ from "moment-timezone";
import _ from "lodash";

import { errorMessage } from "../../Utils";

let cancelToken;

class ConfigurationList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      configurationList: [],
      page: 1,
      limit: 15,
      count: 0,
      search: "",
      sort: { name: "update", direction: "desc" },
      visbleModalDownload: false,
    };
  }

  componentDidMount() {
    this.fetchConfigurationList(this.state.page, this.state.limit);
  }

  async fetchConfigurationList(page, limit) {
    const query = `page=${page}&limit=${limit}&search=${
      this.state.search || ""
    }`;

    if (cancelToken) {
      cancelToken.cancel("Operation canceled due to new request");
    }
    cancelToken = Axios.CancelToken.source();

    await axios
      .get(`configurations?${query}`, {
        cancelToken: cancelToken.token,
      })
      .then((result) => {
        this.setState({
          configurationList: result.data.configurationList,
          page: result.data.page,
          limit: result.data.limit,
          count: result.data.count,
          isLoading: false,
        });
      })
      .catch((err) => {
        if (!Axios.isCancel(err)) {
          errorMessage(err.response || err);
          this.setState({ isLoading: false });
        }
      });
  }

  changePage(page, limit) {
    this.setState({ isLoading: true });
    this.fetchConfigurationList(page, limit);
  }

  checkData(data) {
    return data ? data : null;
  }

  getMuiTheme = () =>
    createMuiTheme({
      typography: {
        useNextVariants: true,
      },
      overrides: {
        MUIDataTableBodyCell: {
          root: {
            "white-space": "nowrap",
            "&:nth-child(1)": {
              width: "8em",
              "min-width": "8em",
              "max-width": "8em",
              "word-break": "break-all",
            },
          },
        },
      },
    });

  render() {
    //Columns
    const columns = [
      {
        name: "Action",
        options: {
          sort: false,
        },
      },
      {
        name: "Nama",
        options: {
          sort: true,
        },
      },
      {
        name: "Value",
        options: {
          sort: true,
        },
      },
      {
        name: "Hari/Tgl Update",
        options: {
          sort: true,
        },
      },
    ];

    //Data configurationList
    const configurationList = this.state.configurationList.map((item, idx) => {
      return [
        <Tooltip placement="bottom" title="Edit User">
          <Button
            type="primary"
            icon="edit"
            onClick={() =>
              this.props.history.push({
                pathname: `/home/configurations/${item.id}/update`,
              })
            }
          />
        </Tooltip>,
        this.checkData(item.name),
        this.checkData(item.percent) + "%",
        momentTZ(item.updatedAt)
          .tz("Asia/Jakarta")
          .format("dddd, D MMMM YYYY HH:mm"),
      ];
    });

    //Options
    const options = {
      filter: false,
      responsive: "simple",
      fixedHeader: true,
      tableBodyHeight: "460px",
      print: false,
      selectableRows: "none",
      // resizableColumns: true,
      download: false,
      viewColumns: false,
      serverSide: true,
      rowsPerPage: this.state.limit,
      count: this.state.count,
      page: this.state.page - 1,
      searchText: this.state.search,
      sortOrder: this.state.sort,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.changePage(tableState.page + 1, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.changePage(1, tableState.rowsPerPage);
            break;
          case "search":
            this.setState({ search: tableState.searchText }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          case "sort":
            this.setState({ sort: tableState.sortOrder }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          default:
            break;
        }
      },
    };

    return (
      <Card
        title="Configuration"
        style={{
          marginTop: 35,
          background: "#fff",
          minHeight: 360,
        }}>
        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <MuiThemeProvider theme={this.getMuiTheme()}>
            <MUIDataTable
              title="Configuration"
              data={configurationList}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
        </Spin>
      </Card>
    );
  }
}

export default ConfigurationList;



// WEBPACK FOOTER //
// src/components/Dashboard/Configuration/ConfigurationList.js